import { Descriptions } from "@/components/v2";
import { type DescriptionsProps } from "antd";
import {
  type Dossier,
  type RepairDirectGlassDossier,
  isRepairDirectGlassDossier,
} from "@rumble-it/common-lib/types/models/Dossier.interface";
import { Card } from "@rumbledirect/ui";

interface GlassDossierCardProps {
  dossier: Dossier | undefined;
  isLoading?: boolean;
}

const formatBoolean = (
  value: boolean | null | undefined,
): string | undefined => {
  if (value === true) return "Ja";
  if (value === false) return "Nee";
  return undefined;
};

export const GlassDossierCard = ({
  dossier,
  isLoading,
}: GlassDossierCardProps) => {
  const glassDossier: RepairDirectGlassDossier | undefined =
    dossier && isRepairDirectGlassDossier(dossier) ? dossier : undefined;

  // Labels are aligned with the questions/choices from the glass survey
  // widget (see forms/widget/arval/survey-glass.json) so admins recognize
  // the same terminology the driver saw while filling in the survey.
  const allItems: DescriptionsProps["items"] = [
    {
      label: "Beschadigde ruit",
      children: glassDossier?.glassDamageLocation?.label,
    },
    {
      label: "Type glasschade",
      children: glassDossier?.glassDamageType?.label,
    },
    {
      label: "Herstel of vervanging",
      children: glassDossier?.glassJobType?.label,
    },
    {
      label: "Aantal sterretjes",
      children: glassDossier?.numberOfDamagePoints,
    },
    {
      label: "Sterretje groter dan een \u20ac2 munt",
      children: formatBoolean(glassDossier?.damageSizeLargerThanCoin),
    },
    {
      label: "Schade binnen 3cm van de rand",
      children: formatBoolean(glassDossier?.damageNearEdge),
    },
    {
      label: "Schade in het gezichtsveld van de bestuurder groter dan 1cm?",
      children: formatBoolean(glassDossier?.damageInDriverVision),
    },
  ];

  const items = allItems.filter(
    (item) => item.children !== undefined && item.children !== null,
  );

  return (
    <Card loading={isLoading} className="w-full" title="Glasschade informatie">
      <Descriptions items={items} />
    </Card>
  );
};
